/**
 * User Mapper
 * Maps between API DTOs and Domain Entities
 */

import {
  UserWithPermissionsDTO,
  CreateUserRequestDTO,
  UsersResponseDTO,
  AssignableManagersResponseDTO,
} from "../models/UserDTOs";
import { UserEntity } from "../../domain/entities/UserEntity";
import { PermissionMapper } from "./PermissionMapper";

export class UserMapper {
  /**
   * Convert UserWithPermissionsDTO to UserEntity
   */
  static toUserEntity(dto: UserWithPermissionsDTO): UserEntity {
    return {
      id: dto.id,
      email: dto.email,
      userName: dto.userName,
      role: dto.role,
      role_id: dto.role_id,
      manager_id: dto.manager_id,
      manager_name: dto.manager_name,
      date_created: dto.date_created,
      is_active: dto.is_active,
      permissions: dto.permissions
        ? PermissionMapper.toPermissionEntity({
            success: true,
            data: { permissions: dto.permissions },
          })
        : undefined,
    };
  }

  /**
   * Convert UsersResponseDTO to UserEntity array
   */
  static toUserEntityArray(dto: UsersResponseDTO): UserEntity[] {
    return (dto.data || []).map((userDto) => this.toUserEntity(userDto));
  }

  /**
   * Convert UserEntity to CreateUserRequestDTO
   * @deprecated This method is no longer used. Use role_id directly in API calls.
   */
  static toCreateUserRequest(entity: {
    email: string;
    userName?: string;
    password: string;
    role_id: number;
    manager_id?: number;
  }): CreateUserRequestDTO {
    return {
      email: entity.email,
      userName: entity.userName,
      password: entity.password,
      role_id: entity.role_id,
      manager_id: entity.manager_id,
    };
  }

  /**
   * Convert AssignableManagersResponseDTO to UserEntity array (simplified)
   */
  static toAssignableManagersArray(
    dto: AssignableManagersResponseDTO
  ): Array<{ id: number; email: string; userName?: string; role: string }> {
    return dto.data || [];
  }
}
